import React from 'react';

import { Heading, LoadingIcon, Stack } from '@eluve/components';

export const GeneratingOutput: React.FC = () => {
  return (
    <Stack
      className="h-96 overflow-hidden rounded-md"
      align="center"
      justify="start"
    >
      <Heading
        size="3xl"
        weight="bold"
        level={3}
        className="relative z-20 text-center"
      >
        Generating Output
      </Heading>

      <LoadingIcon size="3xl" className="text-text-accent-secondary" />
    </Stack>
  );
};
